module.exports = __webpack_public_path__ + "static/img/4.9e4664d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/4.png
// module id = fzt1
// module chunks = 0